
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import { mapState, mapGetters } from "vuex";
import {
    HttpB2cAllErrorList,
    HttpCancelOrder,
    HttpRecoveryNormal,
} from '@/service/boss/b2corder'
import cancelorder from '../alert/cancelorder'
import comAddnotes from '../alert/addnotes'
import comIndex from '../update/index'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design'

export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        cancelorder,
        comAddnotes,
        comIndex,
        compUpload: () => import("@components/templates/upload"),
    },
    data () {
        return {
            // title: "B2C订单",
            isSuper: this.$store.state.userinfo.isSuper,
            hongren: '/picture/hongren.png',
            prime: '/picture/prime.png',
            bufa: '/picture/bufa.png',
            fudingdan: 0,
            formData: {
                page: 1,
                rows: 100,
                sidx: 'id',
                sord: 'desc',
            },
        };
    },
    methods: {
        httpList: HttpB2cAllErrorList,
        handleOperate (data, type) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: data,
                        querytype: 'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'errorderUpdate',
                        params: { type: 'query' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit': {
                    const url = this.$router.resolve({
                        name: 'errorderUpdate',
                        params: { type: 'edit' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'cancel': {
                    this.operate = {
                        title: '取消订单',
                        show: true,
                        width: 600,
                        component: "cancelorder",
                        type,
                        id: data,
                    }
                    break;
                }
                case 'backnormal': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: '恢复正常',
                        desc: `确定要将订单恢复为正常处理的订单？`,
                        type,
                    }
                    break;
                }
                case 'addnotes': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.operate = {
                        title: '添加备注',
                        show: true,
                        width: 600,
                        component: "comAddnotes",
                        activeids: this.checkedId,
                    }
                    break;
                }
            }
        },

        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'backnormal': request = HttpRecoveryNormal; params = { orderIds: this.checkedId.join(','), recoveryNormal: 1 }; break;
                case 'cancel': request = HttpCancelOrder; params = { orderId: this.operate.id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
                // console.log(this.checkedId)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },

    },
    computed: {
        ...mapState('boss', ['productLineAll']),
        ...mapGetters('dictionary', ['getOrgList', 'getNewAllWarehouseIdList']),
        columns () {
            // this.title =  "异常订单"
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: "操作",
                width: 100,
                render: (h, { row }) => {
                    const id = row.id, status = row.orderStatus;
                    return <Dropdown placement="bottom-start" trigger="click">
                        <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                        <DropdownMenu slot="list" class="text-left">
                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query', row.parentId)}>查看</DropdownItem>
                        </DropdownMenu>
                    </Dropdown >
                }
            },
            {
                title: '组织',
                width: 100,
                render: (h, { row }) => {
                    const id = row.orgId;
                    const org = this.getOrgList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div><span class="font-bold">{org.label}</span></div>
                    </div>
                },
            },
            {
                title: '账号/项目/订单号/平台订单号',
                render: (h, { row }) => {
                    const id = row.lineId;
                    const product = this.productLineAll.filter((item) => {
                        return id == item.id
                    })[0] || {};
                    var urgent = false;
                    if (row.saleOrderDetails.systemShipServiceLevel == 1) {
                        urgent = true;
                    }
                    return <div>
                        <div>{row.channelFlag}[{row.channel}]</div>
                        <div><span class="font-bold">{product.name || '-'}</span></div>
                        <div>
                            <a onClick={this.handleOperate.bind(this, row.id, 'query', row.parentId)}>{row.id}</a>
                            <a onClick={this.handleOperate.bind(this, row.id, 'queryBlank', row.parentId)}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        <div>
                            <Tooltip placement="top" content="加急订单（最晚发货时间在24小时内）">
                                <span v-show={urgent} class="order-urgent-span margin-right-10" style="cursor: pointer;">急</span>
                            </Tooltip>{row.orderNo}
                        </div>
                    </div>

                },
            },
            {
                title: '订单状态',
                width: 90,
                render: (h, { row }) => {
                    switch (row.orderStatus) {
                        case 'pending': return <Button class="b2cspan-error span-padding">未支付</Button>; break;
                        case 'unshipped': return <Button class="b2cspan-middle-content span-padding">未发货</Button>; break;
                        case 'approved': return <Button class="b2cspan-success span-padding">已审核</Button>; break;
                        case 'assigned': return <Button class="b2cspan-primary span-padding">已分配</Button>; break;
                        case 'picked': return <Button class="b2cspan-info span-padding">已配货</Button>; break;
                        case 'shipped': return <Button class="b2cspan-light-content span-padding">已发货</Button>; break;
                        case 'canceled': return <Button class="b2cspan-warning span-padding">已取消</Button>; break;
                        case 'refunded': return <Button class="b2cspan-dark-primary span-padding">已退款</Button>; break;
                    }

                },

            },
            {
                title: 'SellerSKU/销售金额',
                // width:250,
                render: (h, { row }) => {

                    let sellers = row.saleOrderItemsList.map(item => {
                        return <div>{item.sellerSku ? item.sellerSku : item.erpSku} * {item.quantity}</div>
                    })

                    return <div>
                        <div >{sellers}</div>
                        <div class="font-bold">{row.amount} {row.currencyCode}</div>
                        <div class="b2ccolor-warning font-weight" v-show={row.fulfillmentChannel == 'MFN'}>{row.fulfillmentChannel}</div>
                        <div class="b2ccolor-success font-weight" v-show={row.fulfillmentChannel == 'AFN'}>{row.fulfillmentChannel}</div>
                    </div>
                },

            },
            {
                title: '仓库/发货Carrier/发货方式',
                // width:200,
                render: (h, { row }) => {
                    if (row.orgWarehouseId != 0) {
                        const id = row.orgWarehouseId,
                            result = this.getNewAllWarehouseIdList.filter((item) => {
                                return item.value == id;
                            })[0] || {};

                        return <div>
                            <div>{result.label}</div>
                            <div>{row.saleOrderDetails.carrier || '-'}</div>
                            <div>{row.shippingMethodCode || '-'}</div>
                        </div>
                    } else {
                        return <div>
                            <div>未分配到仓库</div>
                            <div>{row.saleOrderDetails.carrier || '-'}</div>
                            <div>{row.shippingMethodCode || '-'}</div>
                        </div>
                    }

                },

            },
            {
                title: '订单类型/标记',
                width: 170,
                render: (h, { row }) => {
                    var ordertype;
                    switch (row.orderType) {
                        case 'normally': ordertype = <div class="b2ccolor-dark-primary font-weight span-padding">正常销售</div>; break;
                        case 'celebrity': ordertype = <div class="b2ccolor-error font-weight span-padding">展示订单</div>; break;
                        case 'distribution': ordertype = <div class="b2ccolor-success font-weight span-padding">分销订单</div>; break;
                        case 'brush': ordertype = <div class="b2ccolor-warning font-weight span-padding">刷评订单</div>; break;
                        case 'DELIVERY': ordertype = <div class="b2ccolor-warning font-weight span-padding">发货订单</div>; break;
                    }
                    const urls = {
                        isCelebrity: '/picture/hongren.png',
                        isSample: '/picture/yangpin.png',
                        isReshipment: '/picture/bufa.png',
                        isDismantlementfu: '/picture/chaifu.png',
                        isDismantlementzi: '/picture/chaizi.png',
                        isAddition: '/picture/lipin.png',
                    }
                    const titles = {
                        isCelebrity: '红人订单',
                        isSample: '样品订单',
                        isReshipment: '补发订单',
                        isDismantlementfu: '拆解父订单',
                        isDismantlementzi: '拆解子订单',
                        isAddition: '礼品订单',
                    }
                    var imgs = ['isCelebrity', 'isSample', 'isReshipment', 'isDismantlement', 'isAddition'].map((val) => {
                        if (val == 'isDismantlement' && row['isDismantlement'] == 'Y' && row.parentId == 0) {

                            return h('span', [
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,
                                        content: titles['isDismantlementfu']
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            src: urls['isDismantlementfu'],
                                            style: "width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                            // return <img style="width:20px;height:20px;cursor: pointer;" src={urls['isDismantlementfu']} title={titles['isDismantlementfu']}  alt={titles['isDismantlementfu']} />


                        } else if (val == 'isDismantlement' && row['isDismantlement'] == 'Y' && row.parentId != 0) {

                            return h('span', [
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,
                                        content: titles['isDismantlementzi']
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            src: urls['isDismantlementzi'],
                                            style: "width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                            // return <img style="width:20px;height:20px;cursor: pointer;" src={urls['isDismantlementzi']} title={titles['isDismantlementzi']} alt={titles['isDismantlementzi']}/>
                        } else {

                            return row[val] == 'Y' ? h('span', [
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,
                                        content: titles[val]
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            src: urls[val],
                                            style: "width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ]) : ''

                            // return row[val]== 'Y' ? <img style="width:20px;height:20px;cursor: pointer;" src={urls[val]} title={titles[val]} alt={titles[val]}/> : ''
                        }
                    })
                    var orderFont;

                    if (row.isPrime == 'Y') {
                        orderFont = <span class="b2cfont-italic b2ccolor-info">Prime</span>
                    } else if (row.isOnsite == 'Y') {
                        orderFont = <span class="b2cfont-italic b2ccolor-content">Onsite</span>
                    } else if (row.isBusinessOrder == 'Y') {
                        orderFont = <span class="b2cfont-italic b2ccolor-error">Business</span>
                    } else if (row.shipmentType == 1) {
                        orderFont = <span class="b2cfont-italic b2ccolor-warning">Store</span>
                    }

                    var errorcode;
                    switch (row.errorCode) {
                        // case 'unexception': errorcode = '无异常的订单'; break;
                        case 'systemException': errorcode = '系统异常'; break;
                        case 'produceException': errorcode = '商品无法关联'; break;
                        case 'addressException': errorcode = '订单地址异常'; break;
                        case 'updateException': errorcode = '订单更新异常'; break;
                        case 'pickingException': errorcode = '订单配货异常'; break;
                        case 'cancelException': errorcode = '订单取消异常'; break;
                        case 'trackingException': errorcode = 'Tracking异常'; break;
                        case 'costException': errorcode = '订单成本异常'; break;
                        case 'carrierException': errorcode = '订单发运方式异常'; break;
                        case 'uploadException': errorcode = '订单附件上传异常'; break;
                    }
                    return <div>
                        <div>{ordertype}{imgs}</div>
                        <div>{orderFont}</div>
                        <div v-show={errorcode}><span class="error-span margin-right-10">{errorcode}</span></div>
                    </div>
                }
            },
            {
                title: '创建/最晚发货/仓库预计发货时间',
                width: 200,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.channelCreated || '-'}</div>
                        <div>{row.latestShipDate || '-'}</div>
                        <div>{row.saleOrderDetails.warehouseExpectedShipDate || '-'}</div>
                    </div>

                },
            },

            ];

            if (this.$route.name == 'b2cOrder') {
                datalist.splice(8, 1)
            }
            return datalist;
        },
    },
};




